<template>
  <div>
    <ContentWrapperControl class="mt-4">
      <div class="bg-white p-4 rounded-lg shadow">
        <div class="mb-3">
          <TextControl
            @typing="typing"
            v-bind:value="tin"
            name="tin"
            type="tin"
            :maxlength="11"
          />
        </div>
        <div>
          <ButtonControl
            v-on:click="update"
            v-bind:disabled="disabled"
          >
            {{ lang("lbl_0000294") }}
          </ButtonControl>
        </div>
      </div>
      <PrivacyInfoControl />
    </ContentWrapperControl>
  </div>
</template>

<script>
import ButtonControl from "./../../components/controls/ButtonControl.vue";
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import TextControl from "./../../components/controls/TextControl.vue";
import PrivacyInfoControl from "@/components/controls/PrivacyInfoControl.vue";
import User from "./../../services/User.js";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  components: {
    ButtonControl,
    ContentWrapperControl,
    TextControl,
    PrivacyInfoControl,
  },
  data() {
    return {
      theme: "error",
      display: false,
      message: "",
      changed: false,
      disabled: true,
      tin: null,
      has_tin: this.$store.state.info.tin != null,
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", true);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000276"),
      show: true,
      back: true,
    });

    let state = this.$store.state;
    this.tin = state.enroll.tin;

    if (this.$store.state.info.tin) {
      this.$router.push("/dashboard");
    }
  },
  methods: {
    typing(n) {
      
      let state = this.$store.state;
      let value = n.value.replace(/[^0-9]/g, "");

      if (value.length > 3 && value.length <= 6) {
        value = value.slice(0, 3) + "-" + value.slice(3);
      } else if (value.length > 6) {
        value =
          value.slice(0, 3) + "-" + value.slice(3, 6) + "-" + value.slice(6, 9);
      }
      this.tin = value;
      state.enroll.tin = this.tin;
      this.disabled =
        this.tin.length != 11 || this.tin == this.$store.state.info.tin;
    },
    update() {
      this.$emit("showloader");
      let state = this.$store.state;
      User.updateTin(this.$store.state.key, this.tin)
        .then(() => {
          state.info.tin = this.tin;
          state.enroll.tin = null;
          this.disabled = true;
          this.changed = false;
          this.$emit("hideloader");
          this.$emit("success", this.lang("lbl_0000068"));

          if(!state.info.date_of_birth){
            this.$router.push("/user/info/checklist/optional");
            return;
          }
          this.$router.push("/");
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
    closed() {
      this.display = false;
    },
  },
  watch: {
    tin(val) {
      this.changed = val != this.$store.state.info.tin;
    },
  },
};
</script>
